document.addEventListener("DOMContentLoaded", () => {
  const style = document.createElement("style")
  style.textContent = `
    .bee-cart__originalPrice,
    .bee-cart__discountPrice {
      display: none !important;
    }
  `
  document.head.appendChild(style)

  // Alternatively, you can apply the style directly to the elements:
  const priceElements = document.querySelectorAll(".bee-cart__originalPrice, .bee-cart__discountPrice")
  priceElements.forEach((element) => {
    element.style.display = "none"
  })
})

